export default __webpack_public_path__ + "3bbdfc2.png";